import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { MatDialog } from '@angular/material/dialog';
import { ContactDialogComponent } from '../../../contact-dialog/components/contact-dialog/contact-dialog.component';
import { IBasicInfo, IFundraiser } from '../../../../fundraiser/models/fundraiser.model';
import { VwoService, VariablesService } from '../../../../shared/services';
import { UtilService } from '../../../../shared/services/util/util.service';

@Component({
  selector: 'app-benficiary-card',
  templateUrl: './benficiary-card.component.html',
  styleUrls: ['./benficiary-card.component.scss']
})
export class BenficiaryCardComponent implements OnInit {

  @Input() public fundraiser: IFundraiser;
  @Input() public basicInfo: IBasicInfo;
  @Input() public beneficiary;
  @Input() public donationCard;
  @Input() public sharyCard;
  @Input() public isDonated;
  @Input() public isFundraiserEnded;
  @Input() public tickrIsShown;
  @Input() public type;
  @Input() public contact = true;
  userData;
  @Input() public order;
  @Input() public currency;

  @Output() public watchVideo = new EventEmitter();
  isMobile: any;
  showPopover;

  constructor(
    public util: UtilService,
    public dialog: MatDialog,
    public vwo: VwoService,
    public _bottomSheet: MatBottomSheet,
    public vars: VariablesService
  ) {
  }

  ngOnInit() {
    this.isMobile = this.util.isMobile();
    this.vars.userData.subscribe(res => {
      this.userData = res;
    })
  }
  /**Open contact dialog */
  openDialog() {
    this.dialog.open(ContactDialogComponent, {
      data: {
        title: this.beneficiary.full_name,
        id: this.fundraiser.id,
        contact: this.fundraiser.non_medical ? 'ngo' : ''
      },
      width: '100vw',
      maxWidth: '590px',
      maxHeight: '98vh',
      panelClass: ['round-dialog', 'contact-modal']
    });
  }

  /**Scroll to appealing video section */
  scrollToVideo() {
    this.watchVideo.emit(true);
  }

  /**Open bottom sheet of the verified team messages */
  openBottomSheet(template): void {
    this._bottomSheet.open(template, {
      panelClass: 'bottom-sheet-container'
    });
  }

  closesheet() {
    this.showPopover = false;
    window.removeEventListener('scroll', this.getPosition);
    this._bottomSheet.dismiss()
  }

  popovershow() {
    if (this.util.isBrowser) {
      this.showPopover = true;
      setTimeout(() => {
        this.getPosition();
      }, 0);
      window.addEventListener('scroll', this.getPosition);
    }
  }

  getPosition() {
    let pop = document.getElementById('popoverelement');
    const verified = document.getElementById('verified').getBoundingClientRect();
    const elementHeight = verified.bottom;
    const viewHeight = window.innerHeight;
    if (elementHeight > viewHeight - 300) {
      pop.style.top = "-220px";
    } else {
      pop.style.top = "100px";
    }
  }
}
